module.exports = __webpack_public_path__ + "img/info-02.1220e14c.jpg";